'use client'
import { EntityItemProps } from './EntityItem/EntityItem.types'
import EntityItem from './EntityItem'

const EntitiesList = ({ items }: { items: EntityItemProps[] }) => {
  return (
    <div>
      {items.map((item, index) => (
        <EntityItem
          key={index}
          {...item}
          listNumber={index}
        />
      ))}
    </div>
  )
}

export default EntitiesList
